<template>
  <va-edit-layout>
    <news-form :id="id" :title="title" :item="item"></news-form>
  </va-edit-layout>
</template>

<script>
export default {
  props: ["id", "title", "item"],
};
</script>
